export enum ImportType {
  leaves = 'LEAVES_IMPORT',
}

export enum ImportFormat {
  csv = 'csv',
  excel = 'Excel',
}